<script>
import clientLogos from '@/data/clients';

export default {
	setup() {
		return {
			clientLogos,
		};
	},
};
</script>

<template>
	<div class="mt-10 sm:mt-20">
		<div class="text-center mb-8 sm:mb-10">
			<p
				class="font-display uppercase tracking-wide text-2xl sm:text-3xl font-bold text-primary-light mb-2"
			>
				Companies That Trust Us
			</p>
		</div>

		<div
			class="flex flex-wrap justify-center gap-x-6 gap-y-10 sm:gap-x-10 sm:gap-y-12"
		>
			<div
				v-for="(logo, index) in clientLogos"
				:key="index"
				class="w-1/2 sm:w-1/4 flex items-center justify-center px-3"
			>
				<img
					:src="logo"
					:alt="`Client logo ${index + 1}`"
					class="max-h-12 sm:max-h-14 w-auto object-contain"
				/>
			</div>
		</div>
	</div>
</template>

<style scoped></style>
